import cn from 'classnames';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Icon } from '@.ui';

import { ItemProps, Sizes } from './types';

const getSizeClass = (size: Sizes) => {
    switch (size) {
        case '1/3':
            return ' third';
        case '2/3':
            return ' two-thirds';
        default:
            return '';
    }
};

export const Item = React.forwardRef<HTMLDivElement, ItemProps>(({ className, more, title, children, head, size = 'auto', additional, ...props }, ref) => {
    const navigator = useNavigate();

    return (
        <div className={cn('board_item', head, getSizeClass(size), additional, className)} ref={ref} {...props}>
            {title && (
                <div className="board_item__header">
                    <h3>{title}</h3>
                    {more && (
                        <div className="board_item__header-more" onClick={() => navigator(more)}>
                            More <Icon name="chevron-right" />
                        </div>
                    )}
                </div>
            )}
            {children}
        </div>
    );
});
